import script from "./yetd-svc-reqst-dl.vue?vue&type=script&setup=true&lang=js"
export * from "./yetd-svc-reqst-dl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__